import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  FormControl
} from 'react-bootstrap';

import { Field, formValueSelector, reduxForm } from 'redux-form';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import cx from 'classnames';
import { connect, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import submit from './submit'
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import messages from '../../../locale/messages';
import validate from './validate';
import Loader from '../../Common/Loader/Loader';
import bt from '../../../components/commonStyle.css';
import s from './ConfigSettingsForm.css';


const ConfigSettingsForm = (props) => {
  const {
    handleSubmit,
    submitting,
    error,
    intl: { formatMessage },
  } = props;
  const selector = formValueSelector('ConfigSettingsForm')
  const enableFirebase = useSelector((state) => selector(state, 'enableFirebase'))

  const enableFirebaseOptions = [
    { value: "true", label: formatMessage(messages.Enable) },
    { value: "false", label: formatMessage(messages.Disable) }
  ];

  const payPalHostOptions = [
    { value: "https://api-m.sandbox.paypal.com", label: 'https://api-m.sandbox.paypal.com (Sandbox)' },
    { value: "https://api-m.paypal.com", label: 'https://api-m.paypal.com (Live)' }
  ];

  return (
    <div>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageSiteConfig)}</h1>
      <form onSubmit={handleSubmit(submit)}>
        {error && <strong>{error}</strong>}

        {/* Stripe Settings */}
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.stripeSettings)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="stripePublishableKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.stripePublishableKey)}
            placeholder={formatMessage(messages.stripePublishableKey)}
            toolTipText={formatMessage(messages.siteConfigStripePublicKeyTooltip)}
            showToolTip
          />
          <Field
            name="stripeSecretKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.stripeSecretKey)}
            placeholder={formatMessage(messages.stripeSecretKey)}
            toolTipText={formatMessage(messages.stripeSecretKeyTooltip)}
            showToolTip
          />
        </div>
        <div className={bt.sectionDividerBorder} />
        {/* Paypal Settings */}
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.payPalSettings)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="payPalClientId"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            placeholder={formatMessage(messages.payPalClientId)}
            label={formatMessage(messages.payPalClientId)} />
          <Field
            name="payPalSecret"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            placeholder={formatMessage(messages.payPalSecretKey)}
            label={formatMessage(messages.payPalSecretKey)} />
          <Field
            name='payPalHost'
            label={formatMessage(messages.payPalHost)}
            component={SelectFieldComponent}
            inputClass={bt.formControlSelect}
            options={payPalHostOptions}
          />

        </div>
        <div className={bt.sectionDividerBorder} />
        {/* SMTP Settings */}
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.smtpSettings)}</h2>
        <div className='threeColumnGrid'>
          <Field
            name="smtpHost"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smtpHost)}
            placeholder={formatMessage(messages.smtpHost)}
            toolTipText={formatMessage(messages.siteConfigSmtpHostTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
          <Field
            name="smtpPort"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smtpPort)}
            placeholder={formatMessage(messages.smtpPort)}
            toolTipText={formatMessage(messages.siteConfigSmtpPortTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
          <Field
            name="smptEmail"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smptEmail)}
            placeholder={formatMessage(messages.smptEmail)}
            toolTipText={formatMessage(messages.siteConfigSmtpEmailTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
          <Field
            name="smtpSender"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smtpSender)}
            placeholder={formatMessage(messages.smtpSender)}
            toolTipText={formatMessage(messages.siteConfigSmtpSenderTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
          <Field
            name="smtpSenderEmail"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smtpSenderEmail)}
            placeholder={formatMessage(messages.smtpSenderEmail)}
            toolTipText={formatMessage(messages.siteConfigSmtpSenderEmailTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
          <Field
            name="smtpPassWord"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.smtpPassWord)}
            placeholder={formatMessage(messages.smtpPassWord)}
            toolTipText={formatMessage(messages.siteConfigSmtpPasswordTooltip)}
            inputClass={bt.formControlInput}
            showToolTip />
        </div>
        <div className={bt.sectionDividerBorder} />
        {/* Push Notification */}
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.pushNotificationSettings)}</h2>
        <div className={enableFirebase === 'true' ? 'threeColumnGrid' : 'twoColumnGrid'}>
          <Field
            name="enableFirebase"
            label={formatMessage(messages.firebaseLabel)}
            component={SelectFieldComponent}
            options={enableFirebaseOptions}
            showToolTip
            toolTipText={formatMessage(messages.firebaseTooltip)}
            inputClass={bt.formControlSelect}
          />
          {enableFirebase === 'true' &&
            <>
              <Field
                name="fcmApiKey"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmApiKey)}
                placeholder={formatMessage(messages.fcmApiKey)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmAuthDomain"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmAuthDomain)}
                placeholder={formatMessage(messages.fcmAuthDomain)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmProjectId"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmProjectId)}
                placeholder={formatMessage(messages.fcmProjectId)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmStorageBucket"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmStorageBucket)}
                placeholder={formatMessage(messages.fcmStorageBucket)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmMessagingSenderId"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmMessagingSenderId)}
                placeholder={formatMessage(messages.fcmMessagingSenderId)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmAppId"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmAppId)}
                placeholder={formatMessage(messages.fcmAppId)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmMeasurementId"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmMeasurementId)}
                placeholder={formatMessage(messages.fcmMeasurementId)}
                inputClass={bt.formControlInput} />
              <Field
                name="fcmVapidKey"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.fcmVapidKey)}
                placeholder={formatMessage(messages.fcmVapidKey)}
                inputClass={bt.formControlInput} />
            </>}
          <Field
            name="fcmPushNotificationKey"
            component={InputFieldComponent}
            inputClass={bt.formTextArea}
            label={formatMessage(messages.fcmPushNotificationKey)}
            placeholder={formatMessage(messages.fcmPushNotificationKey)}
            toolTipText={formatMessage(messages.siteConfigFcmPushTooltip)}
            componentClass={"textarea"}
            showToolTip
          />
        </div>
        <div className={bt.sectionDividerBorder} />


        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.googleMapLabelForWeb)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="googleMapBrowserApiKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.googleMapBrowserKeyLabel)}
            placeholder={formatMessage(messages.googleMapBrowserKeyLabel)}
            toolTipText={formatMessage(messages.googleMapBrowserKeyToolTip)}
            showToolTip
          />
          <Field
            name="googleMapServerApiKey"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.googleMapServerKeyLabel)}
            placeholder={formatMessage(messages.googleMapServerKeyLabel)}
            toolTipText={formatMessage(messages.googleMapServerKeyToolTip)}
            showToolTip
          />
        </div>
        <div className={bt.sectionDividerBorder} />

        {/* Other Settings */}
        <h2 className='siteAdminSecondaryHeading'>{formatMessage(messages.otherSettings)}</h2>
        <div className='twoColumnGrid'>
          <Field
            name="maxUploadSize"
            type="text"
            component={InputFieldComponent}
            inputClass={bt.formControlInput}
            label={formatMessage(messages.maxUploadLabel)}
            placeholder={formatMessage(messages.maxUploadLabel)}
            toolTipText={formatMessage(messages.siteConfigMaximumImageTooltip)}
            showToolTip
          />
        </div>

        <div className="commonButtonContainer">
          <Loader
            type="button"
            label={formatMessage(messages.submitButton)}
            show={submitting}
            buttonType="submit"
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting}
          />
        </div>
      </form>
    </div>
  );
};

ConfigSettingsForm.propTypes = {
  initialValues: PropTypes.object,
  title: PropTypes.string,
};

const formWrapped = reduxForm({
  form: 'ConfigSettingsForm',
  validate,
})(ConfigSettingsForm);


export default injectIntl(withStyles(bt, s)(connect(null, {})(formWrapped)));
